import React from 'react';
import { Box, Typography } from '@mui/material';
import GridContainer from 'components/shared/GridContainer';
import GridItem from 'components/shared/GridItem';
import Card from 'components/shared/Card';
import { Comment } from 'store/types/Meeting';

interface CommentViewCardProps {
  comment: Comment;
}

const CommentViewCard: React.FunctionComponent<CommentViewCardProps> = ({ comment }) => {
  return (
    <Card title={<Typography variant="h6">Comment</Typography>} bordered>
      <GridContainer spacing={1}>
        <GridItem md={2}>
          <Typography>
            <strong>Commenter:</strong>
          </Typography>
        </GridItem>
        <GridItem md={10}>
          <Typography>{comment.commenter}</Typography>
        </GridItem>

        <GridItem md={2}>
          <Typography>
            <strong>Comment Number:</strong>
          </Typography>
        </GridItem>
        <GridItem md={10}>
          <Typography>{comment.number}</Typography>
        </GridItem>

        {comment.text && (
          <>
            <GridItem md={2}>
              <Typography>
                <strong>Comment Text:</strong>
              </Typography>
            </GridItem>
            <GridItem md={10}>
              <Box sx={{ typography: 'body1' }} dangerouslySetInnerHTML={{ __html: comment.text }} />
            </GridItem>
          </>
        )}

        {comment.action && (
          <>
            <GridItem md={2}>
              <Typography>
                <strong>Action:</strong>
              </Typography>
            </GridItem>
            <GridItem md={10}>
              <Typography>{comment.action}</Typography>
            </GridItem>
          </>
        )}

        {comment.actionCommenterNumber && (
          <>
            <GridItem md={2}>
              <Typography>
                <strong>Commenter:</strong>
              </Typography>
            </GridItem>
            <GridItem md={10}>
              <Typography>{comment.actionCommenterNumber}</Typography>
            </GridItem>
          </>
        )}

        {comment.actionCommentNumber && (
          <>
            <GridItem md={2}>
              <Typography>
                <strong>Comment Number:</strong>
              </Typography>
            </GridItem>
            <GridItem md={10}>
              <Typography>{comment.actionCommentNumber}</Typography>
            </GridItem>
          </>
        )}

        {comment.case && (
          <>
            <GridItem md={2}>
              <Typography>
                <strong>Case:</strong>
              </Typography>
            </GridItem>
            <GridItem md={10}>
              <Typography>{comment.case}</Typography>
            </GridItem>
          </>
        )}
      </GridContainer>
    </Card>
  );
};

export default CommentViewCard;
